export default {
  API_ENDPOINT: 'https://nameless-cliffs-30904.herokuapp.com/api',
  API_KEY: process.env.REACT_APP_API_KEY,
  TOKEN_KEY: 'leBaguette-login-token'
};
